import { ComponentProps } from 'lib/component-props';
import { Pages } from '.generated/Project.CW.model';
import { getPageUrl } from 'lib/utils/get-base-url';
import StructuredData from 'components/StructuredData';
import { useSitecore } from '@sitecore-content-sdk/nextjs';
import { usePathname } from 'next/navigation';
import { MinimalSchemaItem } from 'lib/schema-builders/minimal-schema-item';
import { buildTreatmentPageJsonLd } from 'lib/schema-builders/treatment';
import { buildConditionPageJsonLd } from 'lib/schema-builders/condition';

export type TreatmentSchemaItem = MinimalSchemaItem & {
  treatmentTypes?: {
    targetItem?: {
      name: string;
    };
  };
};

export type TreatmentorConditionSchemaProps = ComponentProps & {
  fields: {
    data: {
      item: {
        relatedSpecialty: {
          targetItems: MinimalSchemaItem[];
        };
        relatedTreatment: {
          targetItems: TreatmentSchemaItem[];
        };
      };
    };
  };
};

const TreatmentOrConditionSchema = (props: TreatmentorConditionSchemaProps) => {
  const pagePath = usePathname();
  const { page } = useSitecore();
  const locale = page.locale !== 'en' ? `/${page.locale}` : '';
  const routeFields = page?.layout.sitecore.route as Pages.ConditionOrTreatment;
  const pageUrl = getPageUrl(`${locale}${pagePath}`);
  const data = props.fields?.data?.item;

  const relatedSpecialty = data?.relatedSpecialty;
  const relatedTreatment = data?.relatedTreatment;

  let jsonData;
  if (routeFields?.fields?.PageType?.name === 'Treatment') {
    jsonData = buildTreatmentPageJsonLd(
      routeFields as Pages.ConditionOrTreatment,
      pageUrl,
      relatedSpecialty?.targetItems?.length ? relatedSpecialty.targetItems : []
    );
  } else if (routeFields?.fields?.PageType?.name === 'Condition') {
    jsonData = buildConditionPageJsonLd(
      routeFields as Pages.ConditionOrTreatment,
      pageUrl,
      relatedTreatment?.targetItems?.length ? relatedTreatment.targetItems : []
    );
  } else {
    return null;
  }

  return (
    <>
      {page.mode.isEditing && (
        <div className={'p-4 card '}>
          <strong>Schema Component</strong>
          {!props?.fields?.data?.item
            ? ' (Click here, then assign/create data in the right panel)'
            : ' (Configured)'}
        </div>
      )}
      <StructuredData data={jsonData} />
    </>
  );
};

export default TreatmentOrConditionSchema;
